import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
// eslint-disable-next-line import/no-unassigned-import
import "swiper/css";
// eslint-disable-next-line import/no-unassigned-import
import "swiper/css/navigation";
// eslint-disable-next-line import/no-unassigned-import
import "swiper/css/pagination";
import { Navigation, Pagination, Autoplay } from "swiper";
import { Box, Flex } from "@chakra-ui/react";
import { type Integration, type IntegrationSimple } from "lib/sanity";
import { Link } from "ui/link";
import { ChevronLeftIcon } from "ui/icons";
import { uniqueId } from "lodash";
import { Button } from "ui/button";

type XtoYLinkSliderProps = {
  variant: "allDestinations" | "allSources";
  integrationChunks: IntegrationSimple[][];
  primaryIntegration: Integration;
  slidesPerView: number;
};
export function XtoYLinkSlider({ variant, primaryIntegration, integrationChunks, slidesPerView }: XtoYLinkSliderProps) {
  const id = uniqueId("x-y-link-slider-"); // React.useId includes invalid characters for CSS selectors :(
  const previousButtonId = `swiper-navigation-prev-${id}`;
  const nextButtonId = `swiper-navigation-next-${id}`;

  return (
    <Box>
      <Swiper
        speed={450}
        threshold={2}
        slidesPerView={slidesPerView}
        modules={[Autoplay, Pagination, Navigation]}
        navigation={{
          prevEl: `#${previousButtonId}`,
          nextEl: `#${nextButtonId}`,
        }}
      >
        {integrationChunks.map((integrations, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <SwiperSlide key={`destination-group-${index}`}>
            <Flex direction="column" gap="smaller" mr="small" h="auto">
              {integrations.map((currentIntegration) => {
                const href =
                  variant === "allDestinations"
                    ? `/integrations/${primaryIntegration.slug}-to-${currentIntegration.slug}`
                    : `/integrations/${currentIntegration.slug}-to-${primaryIntegration.slug}`;
                const linkText =
                  variant === "allDestinations"
                    ? `${primaryIntegration.name} to ${currentIntegration.name}`
                    : `${currentIntegration.name} to ${primaryIntegration.name}`;
                return (
                  <Box key={currentIntegration.slug}>
                    <Link
                      key={currentIntegration.slug}
                      variant="inlineDark"
                      href={href}
                      textStyle={{ base: "caption1", xl: "body3" }}
                      fontSize={{ base: "brand.sm", xl: "brand.md" }}
                      _hover={{ color: "new.blue.700" }}
                    >
                      {linkText}
                    </Link>
                  </Box>
                );
              })}
            </Flex>
          </SwiperSlide>
        ))}
      </Swiper>

      <Flex mt={{ base: "big", md: "bigger" }} gap="smaller">
        <Button id={previousButtonId} aria-label="Previous slide." variant="secondary" leftIcon={ChevronLeftIcon}>
          Prev
        </Button>
        <Button hasRightChevron id={nextButtonId} aria-label="Next slide." variant="secondary">
          Next
        </Button>
      </Flex>
    </Box>
  );
}
